import { forwardRef } from "react";
import { PeoplePicker, PersonType } from "@microsoft/mgt-react";
import styles from "./AlternatePeoplePicker.module.scss";
import { useEmployee } from "../../../hook";

interface Props {
  value?: any;
  onChange?: (value: any) => void;
  placeholder?: string;
}

export const AlternatePeoplePicker = forwardRef((props: Props, ref: any) => {
  const { onChange = () => {}, placeholder = "Thêm nhân viên" } = props;

  const { data: employees } = useEmployee();

  const onApproverPickerChange = (selectedOptions: any) => {
    if (selectedOptions.target.selectedPeople.length === 0) {
      onChange(undefined);
      return;
    }
    const selectedEmployee = [...selectedOptions.target.selectedPeople];

    const alternateEmployees = selectedEmployee.map((emp: any) => {
      const employee = employees.find((e) => e.eMail === emp.userPrincipalName);
      return employee
        ? `${employee.eMail}|${employee.Title}`
        : `${emp?.userPrincipalName}|${emp?.displayName}`;
    });

    onChange(alternateEmployees);
  };

  return (
    <div className={styles.wrapper}>
      <PeoplePicker
        className="people-picker"
        placeholder={placeholder}
        type={PersonType.any}
        selectionChanged={onApproverPickerChange}
      />
    </div>
  );
});
